import * as React from 'react';
import Comment from './sub/comment';
import Link from './sub/link';
import BackgroundMedia from './sub/background-media';
import {
    NativeAdObj,
    DeviceType,
    PageType,
    Vertical,
} from '../../shared/types/ast';
import Logo from './sub/logo';
import Title from './sub/title';
import Advertising from './sub/advertising';
import AspectRatio from './sub/aspect-ratio';
import { Marking } from './sub/advertising';
import { useAd } from '../hooks/ad';
import { isNative } from '../utils/ast';
import { useLoadNativeAd } from '../hooks/native';

type Props = {
    adObj: NativeAdObj;
    marking?: Marking;
    wide?: boolean;
    mobile?: boolean;
};

const MarketContent = ({
    adObj,
    adObj: { native },
    marking = 'partner',
    wide,
    mobile,
}: Props) => (
    <Link
        adObj={adObj}
        className="mod flex"
        style={{
            height: '100%',
        }}
    >
        <AspectRatio ratio={mobile ? '26%' : wide ? '32%' : '72%'}>
            <div
                style={{
                    display: 'flex',
                    flexDirection: wide || mobile ? 'row' : 'column',
                    height: '100%',
                    borderRadius: '8px',
                    overflow: 'hidden',
                    backgroundColor: '#f6f8fb',
                }}
            >
                <Comment placement="content" adObj={adObj} />

                <div
                    style={{
                        display: 'flex',
                        flex: mobile
                            ? '1 1 40%'
                            : wide
                            ? '1 1 55%'
                            : '1 1 auto',
                    }}
                >
                    <BackgroundMedia
                        native={native}
                        style={{
                            flex: '1',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                        }}
                    />
                    <Advertising
                        adObj={adObj}
                        marking={marking}
                        style={{
                            borderTopRightRadius: '8px',
                            borderBottomLeftRadius: '8px',
                            height: '30px',
                            backgroundColor: 'rgba(248, 248, 248, 0.8)',
                            position: 'absolute',
                            right: '0',
                            top: '0',
                            paddingTop: mobile ? '0px' : '4px',
                            paddingRight: '27px',
                            paddingLeft: '11px',
                        }}
                        top={mobile ? '-1px' : '2px'}
                        uppercase={mobile ? false : true}
                    />
                </div>
                <div
                    style={
                        mobile
                            ? {
                                  flex: '1 1 60%',
                                  margin: '8px',
                                  overflow: 'hidden',
                                  position: 'relative',
                                  display: 'flex',
                                  flexDirection: 'row',
                                  justifyContent: 'space-between',
                              }
                            : {
                                  flex: wide ? '1 1 45%' : '0 0 auto',
                                  margin: '16px',
                                  overflow: 'hidden',
                                  position: 'relative',
                                  display: 'flex',
                                  flexDirection: wide ? 'column' : 'row',
                                  justifyContent: wide
                                      ? 'flex-end'
                                      : 'space-between',
                              }
                    }
                >
                    <Title
                        h={3}
                        native={native}
                        id="native-add__title"
                        style={{
                            fontSize: mobile ? '12px' : '28px',
                            fontWeight: 300,
                            fontStyle: 'normal',
                            fontStretch: 'normal',
                            lineHeight: mobile ? '16px' : '34px',
                            letterSpacing: 'normal',
                            color: '#474445',
                            margin: wide && !mobile ? 'auto' : '0px',
                            paddingTop: mobile ? '5%' : '0px',
                            float: 'left',
                            hyphens: 'none',
                            msHyphens: 'none',
                            WebkitHyphens: 'none',
                            flex: '0 1 auto',
                            alignSelf: 'center',
                        }}
                    />

                    <Logo
                        native={native}
                        style={
                            mobile
                                ? {
                                      flex: '0 1 auto',
                                      maxWidth: '44px',
                                      alignSelf: 'flex-end',
                                  }
                                : {
                                      height: mobile ? '30px' : 'auto',
                                      flex: '0 1 auto',
                                      maxHeight: wide ? '70px' : '74px',
                                      maxWidth: wide ? '121px' : '126px',
                                      alignSelf: wide ? 'start' : 'auto',
                                  }
                        }
                    />
                </div>
            </div>
        </AspectRatio>
    </Link>
);

export default MarketContent;

export function MarketContentWithTracking(props: Props) {
    const { adObj } = props;
    useLoadNativeAd(adObj);

    return <MarketContent {...props} />;
}

type MarketContentWithConfigProps = {
    id: string;
    deviceType: DeviceType;
    vertical?: Vertical;
    pageType?: PageType;
    wide?: boolean;
};

export function MarketContentWithConfig(props: MarketContentWithConfigProps) {
    const {
        id,
        deviceType,
        vertical,
        pageType = vertical ? 'section' : 'front',
    } = props;

    const { adObj } = useAd(id, deviceType, pageType, vertical);
    if (adObj && isNative(adObj)) {
        const nativeType = adObj.native.desc2;
        const marking =
            nativeType === 'FinnNativeStylingC' ||
            nativeType === 'Finn_content' ||
            nativeType === 'content'
                ? 'partner'
                : 'sponsor';

        return (
            <MarketContentWithTracking
                adObj={adObj}
                mobile={deviceType === 'mobile'}
                wide={props.wide}
                marking={marking}
            />
        );
    }
    return null;
}
